import { Badge, Tab } from "@material-ui/core";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import * as S from "../styles";
import activitiesIcon from "../../../assets/icons/activities.svg";
import favoriteIcon from "../../../assets/icons/favorite.svg";
import allIcon from "../../../assets/icons/all.svg";
import visitsIcon from "../../../assets/icons/visits.svg";
import conversationsIcon from "../../../assets/icons/conversations.svg";
import { todo, activities, visits, favorites } from "modules/app/utils";
import { useMainState } from "modules/app/contexts";

const unreadMessages = (tab) =>
  tab.reduce(
    (total, item) =>
      (total += item.items.reduce(
        (totalNotRead, contact) =>
          (totalNotRead += contact.unread_messages_count ? 1 : 0),
        0
      )),
    0
  );

function Header({
  contacts,
  handleChange,
  tabValue,
  tabTodo,
  tabVisits,
  tabActivities,
  tabFavorites,
  tabAll,
}) {
  const { t } = useTranslation(["Contacts"]);

  const contactsTodo = useMemo(() => todo(contacts), [contacts]);
  const activitiesItems = useMemo(() => activities(contacts), [contacts]);
  const visitsItem = useMemo(() => visits(contacts), [contacts]);
  const favoriteItem = useMemo(() => favorites(contacts), [contacts]);
  const unreadMessagesTodo = useMemo(() => unreadMessages(contactsTodo), [
    contactsTodo,
  ]);
  const unactivitiesItem = useMemo(() => unreadMessages(activitiesItems), [
    activitiesItems,
  ]);
  const unVisitsItem = useMemo(() => unreadMessages(visitsItem), [visitsItem]);
  const unFavoriteItem = useMemo(() => unreadMessages(favoriteItem), [
    favoriteItem,
  ]);

  return (
    <S.AppBar position="static">
      <S.Tabs
        value={tabValue}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab
          label={
            <S.Label>
              <S.TabTitle>{t("tabs.conversations")}</S.TabTitle>
              <S.TabCounter>{`(${tabTodo})`}</S.TabCounter>
            </S.Label>
          }
          icon={
            <Badge max={99} badgeContent={unreadMessagesTodo}>
              <img src={conversationsIcon} />
            </Badge>
          }
        />

        <Tab
          label={
            <S.Label>
              <S.TabTitle>{t("tabs.visits")}</S.TabTitle>
              <S.TabCounter>{`(${tabVisits})`}</S.TabCounter>
            </S.Label>
          }
          icon={
            <Badge max={99} badgeContent={unVisitsItem}>
              <img src={visitsIcon} />
            </Badge>
          }
        />

        <Tab
          label={
            <S.Label>
              <S.TabTitle>{t("tabs.activities")}</S.TabTitle>
              <S.TabCounter>{`(${tabActivities})`}</S.TabCounter>
            </S.Label>
          }
          icon={
            <Badge max={99} badgeContent={unactivitiesItem}>
              <img src={activitiesIcon} />
            </Badge>
          }
        />

        <Tab
          label={
            <S.Label>
              <S.TabTitle>{t("tabs.favorites")}</S.TabTitle>
              <S.TabCounter>{`(${tabFavorites})`}</S.TabCounter>
            </S.Label>
          }
          icon={
            <Badge max={99} badgeContent={unFavoriteItem}>
              <img src={favoriteIcon} />
            </Badge>
          }
        />

        <Tab
          label={
            <S.Label>
              <S.TabTitle>{t("tabs.all")}</S.TabTitle>
              <S.TabCounter>{`(${tabAll})`}</S.TabCounter>
            </S.Label>
          }
          icon={<img src={allIcon} />}
        />
      </S.Tabs>
    </S.AppBar>
  );
}

export default Header;
